import { useEffect, useState } from "react";
import { ICloseEvent, IMessageEvent, w3cwebsocket } from "websocket";
import { getUsername } from "../../components/shared/helpers/helper";

// 3. Custom Hook for WebSocket (uses context internally)
export const useCaseWebSocket = (caseId: string) => {
  const [userInCaseOpen, setUserInCaseOpen] = useState({
    status: false,
    showSnackbar: false,
    message: "",
    showAvatar: false,
    primary: false,
  });

  useEffect(() => {
    // The development write guard cannot reach this. It is an axios request
    // interceptor; this is a WebSocket, so opening a case still notifies other
    // users from a developer's machine, against production. Do not assume local
    // work is unobservable.
    const client = new w3cwebsocket(
      `wss://2wj854ju50.execute-api.us-east-1.amazonaws.com/prod?room_id=${caseId}&username=${getUsername()}&fullname=${getUsername()}`
    );

    client.onopen = () => {
      console.log("WebSocket Client Connected");
      client.send(
        JSON.stringify({
          action: "sendmessage",
          room_id: caseId,
        })
      );
    };

    client.onmessage = (message: IMessageEvent) => {
      if (message.data) {
        // const parsedMessage = JSON.parse(message.data);
        const data =
          typeof message.data === "string"
            ? message.data
            : message.data.toString();

        const parsedMessage = JSON.parse(data);

        if (parsedMessage.type === "PRIMARY_USER_NOTIFICATION") {
          if (!userInCaseOpen.status) {
            setUserInCaseOpen({
              status: true,
              message: parsedMessage.message,
              showAvatar: true,
              primary: false,
              showSnackbar: false,
            });
          }
        } else if (parsedMessage.type === "PRIMARY__NOTIFICATION") {
          if (!userInCaseOpen.primary) {
            setUserInCaseOpen({
              status: false,
              message: parsedMessage.message,
              showAvatar: true,
              primary: true,
              showSnackbar: true,
            });
          }
        }
      }
    };

    client.onerror = (error: Error) => {
      console.log("WebSocket Error:", error);
    };

    client.onclose = (event: ICloseEvent) => {
      console.log("WebSocket closed:", event.code, event.reason);
    };

    return () => {
      client.close(1000, `${caseId}:${getUsername()}`);
    };
  }, [caseId]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setUserInCaseOpen({
      ...userInCaseOpen,
      status: false,
      showSnackbar: false,
    });
  };

  return { userInCaseOpen, handleClose };
};
